module.exports = {
    etherscan: {
        tx: `https://etherscan.io/tx`,
        account: `https://etherscan.io/address`
    },
    api: {
        game_url: `https://api-lok-beta.leagueofkingdoms.com/api`,
        stat_url: `https://api-stats.leagueofkingdoms.com/api`,
        nft_url: `https://lok-nft.leagueofkingdoms.com/api`,
    },
    web: {
        url: `https://land.leagueofkingdoms.com`        
    },
    card: {
        url: `https://lok-nft.leagueofkingdoms.com/api/card/land`
    },
    eth: {
        net: 1,
        networks:["mainnet", "mainnet", "", "ropsten", "rinkeby"]
    },
    loka: {
        token_address: '0x61e90a50137e1f645c9ef4a0d3a4f01477738406'
    },
    abi: {
        sale: require('./views/KingdomLandSale.live.json')
    }
}